import React, {useEffect} from "react";
import Carousel from "./Carousel";
import AOS from "aos";
import "aos/dist/aos.css";


const Hero = () => {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <section className="container text-white mx-auto px-6 pt-10 pb-10 lg:pt-16">
        <div className="flex justify-between items-center flex-col lg:flex-row gap-10">
          <div className="flex flex-col space-y-5 w-full lg:w-1/2">
            <h1
              data-aos="fade-right"
              data-glitch="glitch"
              data-aos-duration="3000"
              className="text-2xl text-white uppercase font-semibold"
            >
              Introducing Revpoint
            </h1>
            <h1 className="text-4xl sm:text-5xl font-semibold lg:text-6xl 2xl:text-8xl">
              Your Partner in IT Excellence
            </h1>
            <p className="text-md lg:text-xl text-white opacity-75">
              Solving Business Challenges with Technology. Passionate about
              tech-driven solution hardware products, addressing critical client
              challenges effectively.
            </p>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center md:justify-end lg:mt-20 overflow-x-hidden">
              <Carousel/>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
